import React from 'react'
import {
  Toolbar,
  ToolbarButton,
  useGridApiContext,
  gridPaginatedVisibleSortedGridRowIdsSelector,
  gridFilteredSortedRowIdsSelector,
  useGridSelector,
} from '@mui/x-data-grid-premium'
import PropTypes, { any } from 'prop-types'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { Box, Tooltip, Typography } from '../mui/Core/index'
import { useTheme } from '../mui/Styles/index'
import Constants from '../../constants/en.json'

function TableToolBar({ rows }) {
  const theme = useTheme()
  const apiRef = useGridApiContext()
  const isDisabledExport = useGridSelector(apiRef, gridFilteredSortedRowIdsSelector).length === 0

  const handleExport = () => {
    let visibleRowIds = []
    const paginationMode = apiRef.current.state.pagination.paginationMode
    // Get visible rows: Use for client paginated records
    if (paginationMode === 'client') {
      visibleRowIds = gridPaginatedVisibleSortedGridRowIdsSelector(apiRef) || []
    }
    // Get visible rows: Use rows prop for server paginated records
    if (paginationMode === 'server') {
      visibleRowIds = rows.map((row) => row.id) || []
    }
    // Fallback: No data to export
    if (!visibleRowIds || visibleRowIds.length === 0) return

    // Export only visible rows
    apiRef.current.exportDataAsExcel({
      getRowsToExport: () => visibleRowIds,
    })
  }

  const exportToExcelContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    cursor: isDisabledExport ? 'not-allowed' : 'pointer',
    opacity: isDisabledExport ? 0.5 : 1,
    pointerEvents: isDisabledExport ? 'none' : 'auto',
  }
  const toolbarButtonStyle = {
    p: 2,
    mr: 5,
    '&:hover': {
      backgroundColor: `${theme.palette.grey[400]} !important`,
    },
  }

  return (
    <Toolbar>
      <Tooltip arrow title={Constants.table.EXPORT_TO_EXCEL}>
        <Box
          onClick={!isDisabledExport ? handleExport : undefined}
          sx={exportToExcelContainerStyle}
        >
          <Typography variant='body1'>{Constants.table.EXPORT_TO_EXCEL}</Typography>
          <ToolbarButton sx={toolbarButtonStyle} disabled={isDisabledExport}>
            <FileDownloadIcon />
          </ToolbarButton>
        </Box>
      </Tooltip>
    </Toolbar>
  )
}

TableToolBar.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.objectOf(any)).isRequired,
}

export default TableToolBar
